import React, { useState, useEffect } from 'react';
import { Calendar, Users, Filter, Download, ArrowLeft, Search } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';

const AttendanceManagement = () => {
    const navigate = useNavigate();
    const [attendances, setAttendances] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchAttendances();
    }, []);

    const fetchAttendances = async () => {
        try {
            const res = await api.get('/attendance');
            setAttendances(res.data);
        } catch (error) {
            console.error('Failed to fetch attendances');
        } finally {
            setLoading(false);
        }
    };

    const filteredAttendances = attendances.filter(a =>
        a.user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (a.user.employeeId && a.user.employeeId.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const formatDate = (date) => new Date(date).toLocaleDateString();
    const formatTime = (date) => date ? new Date(date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '-';

    return (
        <div className="container section">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
                <button
                    onClick={() => navigate('/dashboard')}
                    style={{ display: 'flex', alignItems: 'center', color: '#4b5563', background: 'none', border: 'none', cursor: 'pointer' }}
                >
                    <ArrowLeft size={20} style={{ marginRight: '0.5rem' }} /> Back to Home
                </button>
                <button className="btn btn-secondary" style={{ display: 'flex', alignItems: 'center' }}>
                    <Download size={18} style={{ marginRight: '0.5rem' }} /> Export Report
                </button>
            </div>

            <h1 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#1f2937', marginBottom: '1.5rem', display: 'flex', alignItems: 'center' }}>
                <Calendar style={{ marginRight: '0.75rem', color: '#2563eb' }} /> Attendance Management
            </h1>

            <div className="glass-card" style={{ padding: '1.5rem', marginBottom: '1.5rem' }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                    <div style={{ position: 'relative', flex: 1 }}>
                        <Search size={18} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#9ca3af' }} />
                        <input
                            type="text"
                            placeholder="Search by employee name or ID..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{ width: '100%', padding: '0.75rem 0.75rem 0.75rem 2.5rem', borderRadius: '0.5rem', border: '1px solid #e5e7eb' }}
                        />
                    </div>
                    <select style={{ padding: '0.75rem', borderRadius: '0.5rem', border: '1px solid #e5e7eb', background: 'white' }}>
                        <option>All Departments</option>
                    </select>
                    <input type="date" style={{ padding: '0.75rem', borderRadius: '0.5rem', border: '1px solid #e5e7eb', background: 'white' }} />
                </div>
            </div>

            <div className="glass-card" style={{ padding: 0, overflow: 'hidden' }}>
                <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                        <thead>
                            <tr style={{ backgroundColor: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
                                <th style={{ padding: '1rem', fontWeight: '600', color: '#4b5563' }}>Employee</th>
                                <th style={{ padding: '1rem', fontWeight: '600', color: '#4b5563' }}>Date</th>
                                <th style={{ padding: '1rem', fontWeight: '600', color: '#4b5563' }}>Check In</th>
                                <th style={{ padding: '1rem', fontWeight: '600', color: '#4b5563' }}>Check Out</th>
                                <th style={{ padding: '1rem', fontWeight: '600', color: '#4b5563' }}>Working Hours</th>
                                <th style={{ padding: '1rem', fontWeight: '600', color: '#4b5563' }}>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan="6" style={{ padding: '2rem', textAlign: 'center' }}>Loading...</td></tr>
                            ) : filteredAttendances.length === 0 ? (
                                <tr><td colSpan="6" style={{ padding: '2rem', textAlign: 'center' }}>No record found</td></tr>
                            ) : (
                                filteredAttendances.map(a => (
                                    <tr key={a.id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                                        <td style={{ padding: '1rem' }}>
                                            <div style={{ fontWeight: '500' }}>{a.user.name}</div>
                                            <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>{a.user.employeeId} • {a.user.department}</div>
                                        </td>
                                        <td style={{ padding: '1rem' }}>{formatDate(a.date)}</td>
                                        <td style={{ padding: '1rem', color: '#059669', fontWeight: '500' }}>{formatTime(a.checkIn)}</td>
                                        <td style={{ padding: '1rem', color: '#dc2626', fontWeight: '500' }}>{formatTime(a.checkOut)}</td>
                                        <td style={{ padding: '1rem' }}>
                                            {a.checkIn && a.checkOut ?
                                                `${((new Date(a.checkOut) - new Date(a.checkIn)) / 1000 / 3600).toFixed(2)} hrs` :
                                                '-'
                                            }
                                        </td>
                                        <td style={{ padding: '1rem' }}>
                                            <span style={{
                                                padding: '0.25rem 0.5rem', borderRadius: '9999px', fontSize: '0.75rem', fontWeight: '600',
                                                backgroundColor: '#dcfce7', color: '#166534'
                                            }}>
                                                {a.status}
                                            </span>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default AttendanceManagement;
